// Not a guided tour: the step is the Brand Identity page itself, in onboarding mode.
const confirmBrand = (baseUrl, navigate, domain) => {
  const status = domain?.brandIdentityStatus;
  return {
    id: 'confirmBrand',
    title: 'Confirm your brand',
    onClick: () => navigate(`${baseUrl}/confirm/brandContext`),
    // Confirmed without a logo for dark backgrounds still counts as done; it is only a reminder.
    note:
      status === 'needsDarkLogo'
        ? 'Add a logo for dark backgrounds when you have one, so your emails look right in dark-mode inboxes.'
        : undefined,
    isComplete: ['confirmed', 'needsDarkLogo'].includes(status),
  };
};

export default confirmBrand;
